module.exports = __webpack_public_path__ + "img/NissanGtr.a9a0a3d2.jpeg";